
import React, { useEffect, useState } from 'react';
import TopDataOffers from '../../components/TopDataOffers';
import { ArrowLeft, ArrowUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function AllDataOffersPage() {
    const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedNetwork, setSelectedNetwork] = useState('All');
  const [showBackToTop, setShowBackToTop] = useState(false);

  // Show/Hide Back to Top button based on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  // Scroll smoothly to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-12">
      {/* <div className="bg-white border-b sticky top-0 z-10 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <h1 className="text-3xl font-bold text-gray-900">All Data Offers</h1>
          <p className="text-gray-600 mt-1">Find the perfect data plan for you</p>
        </div>
      </div> */}

      {/* Header with Back Arrow */}
      <div className="bg-white border-b sticky top-0 z-20 shadow-sm">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-4 py-5">
            {/* Back Button */}
            <button
              onClick={handleBack}
              className="p-2 -ml-2 rounded-full hover:bg-gray-100 active:bg-gray-200 transition-colors"
              aria-label="Go back"
            >
              <ArrowLeft size={28} className="text-gray-700" />
            </button>

            <div>
              <h1 className="text-2xl font-bold text-gray-900">All Data Offers</h1>
              <p className="text-sm text-gray-600 -mt-0.5">
                Browse all available data bundles
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 pt-6">
        {/* Search & Filter Bar */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8">
          <input
            type="text"
            placeholder="Search by data amount, validity..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="flex-1 px-5 py-3 border border-gray-300 rounded-2xl focus:outline-none focus:border-[#3866A3]"
          />

          <select
            value={selectedNetwork}
            onChange={(e) => setSelectedNetwork(e.target.value)}
            className="px-5 py-3 border border-gray-300 rounded-2xl focus:outline-none focus:border-[#3866A3] bg-white"
          >
            <option value="All">All Networks</option>
            <option value="MTN">MTN</option>
            <option value="AIRTEL">Airtel</option>
            <option value="GLO">Glo</option>
            <option value="9MOBILE">9mobile</option>
          </select>
        </div>

        {/* Reused Component with Filters */}
        <TopDataOffers
          title=""
          showAll={true}
          maxItems={200}
          groupByNetwork={selectedNetwork === 'All'}
          randomize={false}
          itemsPerRow={3}
          onOfferPress={(offer) => {
            console.log('Selected Offer:', offer);
            // Replace alert with your modal later
            alert(`Selected: ${offer.data} - ₦${offer.price}`);
          }}
        />
      </div>

      {/* Floating Back to Top Button */}
      {showBackToTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-6 z-50 flex h-14 w-14 items-center justify-center 
                     rounded-full bg-[#3866A3] text-white shadow-xl hover:bg-[#2d5a8c] 
                     active:scale-95 transition-all duration-200"
          aria-label="Back to top"
        >
          <ArrowUp size={28} />
        </button>
      )}
    </div>
  );
}